import React from 'react';
import './Homepage.css';
import lysvevingImage from '../../Assets/lysveving1.jpeg';
import logoImage from '../../Assets/logo.png';

const Homepage = () => {
  return (
    <div className="homepage" style={{'--hero-bg-image': `url(${lysvevingImage})`}}>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-stars">
          <div className="star">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <circle cx="12" cy="12" r="2"/>
              <circle cx="12" cy="12" r="1" fill="white" opacity="0.8"/>
            </svg>
          </div>
          <div className="star">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <circle cx="12" cy="12" r="2"/>
              <circle cx="12" cy="12" r="1" fill="white" opacity="0.8"/>
            </svg>
          </div>
          <div className="star">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <circle cx="12" cy="12" r="2"/>
              <circle cx="12" cy="12" r="1" fill="white" opacity="0.8"/>
            </svg>
          </div>
          <div className="star">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <circle cx="12" cy="12" r="2"/>
              <circle cx="12" cy="12" r="1" fill="white" opacity="0.8"/>
            </svg>
          </div>
          <div className="star">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <circle cx="12" cy="12" r="2"/>
              <circle cx="12" cy="12" r="1" fill="white" opacity="0.8"/>
            </svg>
          </div>
          <div className="star">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <circle cx="12" cy="12" r="2"/>
              <circle cx="12" cy="12" r="1" fill="white" opacity="0.8"/>
            </svg>
          </div>
          <div className="star">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <circle cx="12" cy="12" r="2"/>
              <circle cx="12" cy="12" r="1" fill="white" opacity="0.8"/>
            </svg>
          </div>
          <div className="star">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <circle cx="12" cy="12" r="2"/>
              <circle cx="12" cy="12" r="1" fill="white" opacity="0.8"/>
            </svg>
          </div>
          <div className="star">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <circle cx="12" cy="12" r="2"/>
              <circle cx="12" cy="12" r="1" fill="white" opacity="0.8"/>
            </svg>
          </div>
        </div>
        <div className="hero-content">
          <h1 className="hero-title">Rohde Lysveving</h1>
          <p className="hero-subtitle">Åpne forbindelsen mellom kropp, sjel og universell bevissthet</p>
          <div className="hero-decoration">
            <div className="light-beam"></div>
            <div className="light-beam"></div>
            <div className="light-beam"></div>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="main-content">
        <div className="container">
          <div className="content-section">
            <h2 className="section-title">Hva er Lysveving?</h2>
            
            <div className="text-block">
              <p>
                Lysveving er et dypt energetisk arbeid som åpner og balanserer forbindelsen mellom kropp, sjel og universell bevissthet.
              </p>
            </div>

            <div className="text-block">
              <p>
                Lysveving skjer gjennom stillhet, frekvenser og sjelskontakt og skaper en bro mellom det usynlige og det sanselige, slik at din sjel får uttrykke seg gjennom deg, enten du ligger i ro eller står midt i hverdagen.
              </p>
            </div>

            <div className="text-block">
              <p>
                I lysvevingen arbeider vi med ni ulike Sjelsessenspunkter, som hver bærer en spesiell vibrasjon i kroppens struktur. Disse essensene er portaler mellom vår indre visdom og det større energetiske feltet vi alle er en del av.
              </p>
            </div>

            <div className="highlight-box">
              <p>
                Lysveving er ikke en metode du "mottar", men et rom du trer inn i. Et møte med deg selv gjennom det dype, levende lyset du allerede bærer.
              </p>
            </div>

            <div className="text-block">
              <h3 className="subsection-title">Det er en praksis for deg som søker:</h3>
              <ul className="benefits-list">
                <li>Dypere forankring i kroppen</li>
                <li>Å styrke din intuitive sansing</li>
                <li>Å aktivere din spirituelle intelligens</li>
                <li>Å finne tilbake til roen og klarheten i ditt eget vesen</li>
              </ul>
            </div>

            <div className="text-block final-message">
              <p>
                Du trenger ingen forkunnskaper, bare et åpent hjerte og et ønske om å lytte innover.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Decorative Elements */}
      <div className="floating-elements">
        <div className="floating-light"></div>
        <div className="floating-light"></div>
        <div className="floating-light"></div>
      </div>
    </div>
  );
};

export default Homepage;
